//   ____                       _ _
//  / ___|  ___  ___ _   _ _ __(_) |_ _   _
//  \___ \ / _ \/ __| | | | '__| | __| | | |
//   ___) |  __/ (__| |_| | |  | | |_| |_| |
//  |____/ \___|\___|\__,_|_|  |_|\__|\__, |
//                                    |___/
import Vue from 'vue'
import axios from 'axios'

// JWT payload is Base64URL encoded and contains UTF-8 JSON.
// atob() returns a binary (latin1) string, so we must decode it as UTF-8.
function base64UrlToUint8Array (base64Url) {
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const padded = base64 + '==='.slice((base64.length + 3) % 4)
  const binary = atob(padded)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
  return bytes
}

function decodeJwtPayload (token) {
  if (!token || token.split('.').length < 2) return null
  const bytes = base64UrlToUint8Array(token.split('.')[1])
  const json = new TextDecoder('utf-8').decode(bytes)
  return JSON.parse(json)
}

export default {
  namespaced: true,
  state: {
    error: null,
    isAuthenticated: false,
    switchedFrom: null,
    switched: false,
    token: localStorage.getItem('token') || '',
    user: null,
    baseUser: null,
    baseUserToken: localStorage.getItem('baseUserToken') || null
  },
  getters: {
    hasError (state) {
      return state.error !== null
    },
    error (state) {
      return state.error
    },
    user (state) {
      const jwtData = decodeJwtPayload(state.token)
      state.user = jwtData
      return state.user
    },
    baseUser (state) {
      const jwtData = decodeJwtPayload(state.baseUserToken)
      state.baseUser = jwtData
      return state.baseUser
    },
    baseUserToken (state) {
      return state.baseUser
    },
    isAuthenticated (state) {
      if (state.token === '') {
        return false
      } else {
        return true
      }
    },
    isSwitched (state, getters) {
      return getters.baseUser ? getters.baseUser.userid !== getters.user.userid : false
    },
    hasRole: (state) => (role) => {
      let user = state.user
      if (!user) {
        user = decodeJwtPayload(state.token)
      }
      if (user) {
        if (user.roles.indexOf(role) === -1) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    }
  },
  mutations: {
    AUTHENTICATING_SUCCESS: function (state, token) {
      console.log(token)
      state.error = null
      state.isAuthenticated = true
      state.token = token
      // Token deserialisieren und als User Objekt speichern
      const jwtData = decodeJwtPayload(state.token)
      state.user = jwtData
      if (state.baseUserToken == null) {
        state.baseUserToken = token
        localStorage.setItem('baseUserToken', token)
      }
      if (state.baseUser == null) {
        const jwtBaseData = decodeJwtPayload(state.baseUserToken)
        state.baseUser = jwtBaseData
      }
      console.log('test')
      console.log('jwtData')
      // Localstorage und Axios
      localStorage.setItem('token', token)
      console.log('jwtData', token)
    },
    AUTHENTICATING_ERROR: function (state, error) {
      state.error = error
      state.isAuthenticated = false
      localStorage.removeItem('token')
      state.token = ''
      state.user = null
    },
    AUTHENTICATING_LOGOUT: function (state) {
      state.error = null
      state.isAuthenticated = false
      state.token = ''
      state.user = null
      localStorage.removeItem('token')
      localStorage.removeItem('baseUserToken')
      delete axios.defaults.headers.common.authorization
    }
  },
  actions: {
    AUTH_LOGIN: ({ commit, dispatch }, user) => {
      return Vue.axios.post('/auth/login', {
        username: user.username,
        password: user.password
      }).then(function (response) {
        // Erfolgreiche Authentifizierung
        commit('AUTHENTICATING_SUCCESS', response.data.token)
      })
        .catch(function (error) {
          // Es soll trotz eines 401 den Error aus dem Response Body angezeigt werden
          if (error.response && error.response.status === 401) {
            const data = error.response.data
            if (Vue._.has(data, 'message')) {
              commit('AUTHENTICATING_ERROR', data.message)
            } else {
              // Sollte nicht eintreten, malformed json response
              commit('AUTHENTICATING_ERROR', error)
            }
          } else {
            // Anderer HTTP-Status-Code (zum Beispiel 500)
            commit('AUTHENTICATING_ERROR', error)
          }
        })
    },
    AUTH_USER_SWITCH: ({ commit, dispatch }, switchTo, switchToName) => {
      return Vue.axios.get('userswitch/' + switchTo).then(function (response) {
        // Erfolgreiche Authentifizierung
        commit('AUTHENTICATING_SUCCESS', response.data.token, true)
        return true
      })
        .catch(function (error) {
          // Es soll trotz eines 401 den Error aus dem Response Body angezeigt werden
          if (error.response && error.response.status === 401) {
            const data = error.response.data
            if (Vue._.has(data, 'message')) {
              commit('AUTHENTICATING_ERROR', data.message)
            } else {
              // Sollte nicht eintreten, malformed json response
              commit('AUTHENTICATING_ERROR', error)
            }
          } else {
            // Anderer HTTP-Status-Code (zum Beispiel 500)
            commit('AUTHENTICATING_ERROR', error)
          }
        })
    },
    AUTH_USER_SWITCH_EXIT: ({ commit, dispatch, getters }) => {
      return Vue.axios.get('userswitch/' + getters.baseUser.userid).then(function (response) {
        // Erfolgreiche Authentifizierung
        console.log(response.data.token)
        commit('AUTHENTICATING_SUCCESS', response.data.token, null)
      })
        .catch(function (error) {
          // Es soll trotz eines 401 den Error aus dem Response Body angezeigt werden
          if (error.response && error.response.status === 401) {
            const data = error.response.data
            if (Vue._.has(data, 'message')) {
              commit('AUTHENTICATING_ERROR', data.message)
            } else {
              // Sollte nicht eintreten, malformed json response
              commit('AUTHENTICATING_ERROR', error)
            }
          } else {
            // Anderer HTTP-Status-Code (zum Beispiel 500)
            commit('AUTHENTICATING_ERROR', error)
          }
        })
    },
    AUTH_LOGOUT: ({ commit, dispatch }) => {
      return commit('AUTHENTICATING_LOGOUT')
    }
  }
}
